<div *ngIf="showToolbar" class="pdf-toolbar" role="toolbar" aria-label="PDF tools">
  <span class="pdf-toolbar__pages" aria-live="polite">{{ currentPage }} / {{ totalPages || '–' }}</span>
  <span class="pdf-toolbar__spacer"></span>
  <button type="button" (click)="zoomOut()" [disabled]="!canZoomOut" aria-label="Zoom out"><i class="fas fa-minus" aria-hidden="true"></i></button>
  <button type="button" class="pdf-toolbar__zoom" (click)="resetZoom()" aria-label="Reset zoom">{{ zoomLabel }}</button>
  <button type="button" (click)="zoomIn()" [disabled]="!canZoomIn" aria-label="Zoom in"><i class="fas fa-plus" aria-hidden="true"></i></button>
  <button type="button" (click)="download()" aria-label="Download PDF"><i class="fas fa-download" aria-hidden="true"></i></button>
</div>
<div #scroller class="pdf-scroller" (scroll)="onScroll()">
  <div #pages class="pdf-pages"></div>
  <div #endSentinel class="pdf-end-sentinel"></div>
</div>
